import Lightbox from "bs5-lightbox";
import Choices from "choices.js";
import lottie from "lottie-web";

//Lightbox.initialize;

const options = {
	keyboard: true
};

document.querySelectorAll(".lightbox-toggle").forEach((el) =>
	el.addEventListener("click", (e) => {
		e.preventDefault();
		const lightbox = new Lightbox(el as HTMLImageElement, options);
		lightbox.show();
	})
);


//Page animation
const scrollElements = document.querySelectorAll(".js-scroll");

const elementInView = (el: Element, dividend = 1) => {
	const elementTop = el.getBoundingClientRect().top;

	return (
		elementTop <=
		(window.innerHeight || document.documentElement.clientHeight) / dividend
	);
};

const elementOutofView = (el: Element) => {
	const elementTop = el.getBoundingClientRect().top;

	return (
		elementTop > (window.innerHeight || document.documentElement.clientHeight)
	);
};

const displayScrollElement = (element: Element) => {
	element.classList.add("scrolled");
};

const hideScrollElement = (element: Element) => {
	element.classList.remove("scrolled");
};

const handleScrollAnimation = () => {
	scrollElements.forEach((el) => {
		if (elementInView(el, 1.25)) {
			displayScrollElement(el);
		} else if (elementOutofView(el)) {
			hideScrollElement(el);
		}
	});
};

window.addEventListener("scroll", () => {
	handleScrollAnimation();
});

//Timeline
function toggleNextSibling(event: { preventDefault: () => void; currentTarget: { querySelector: (arg0: string) => any; parentElement: any; }; }) {
	event.preventDefault();
	[].forEach.call(
		document.querySelectorAll(".vr"),
		function (el: {
			style: {
				transform: any; opacity: number
			}
		}) {
			el.style.opacity = 0;
			el.style.transform = 'translate3d(0, -100%, 0)';
		}
	);
	[].forEach.call(
		document.querySelectorAll(".information"),
		function (el: {
			style: {
				opacity: number;
			};
		}) {
			el.style.opacity = 0.3;
		}
	);
	var verticalLine = event.currentTarget.querySelector(".vr");
	verticalLine.style.opacity = 1;
	verticalLine.style.transform = "translate3d(0, -50%, 0)";
	var verticalLine = event.currentTarget.querySelector(".information");
	verticalLine.style.opacity = 1;

	[].forEach.call(
		document.querySelectorAll(".logo"),
		function (el: {
			style: {
				transform: string; opacity: number
			}
		}) {
			el.style.opacity = 0;
			el.style.transform = "translate3d(0, -20%, 0)";
		}
	);
	var parentDiv = event.currentTarget.parentElement;
	var imageDiv = parentDiv.querySelector(".logo");
	imageDiv.style.opacity = 1;
	imageDiv.style.transform = "translate3d(0, 0, 0)";
}

Array.prototype.slice
	.call(document.querySelectorAll(".timeline-text"))
	.forEach(function (head) {
		head.addEventListener("click", toggleNextSibling);
	});

window.addEventListener("resize", function () {
	if (window.innerWidth > 768) {
		Array.prototype.slice
			.call(document.querySelectorAll(".timeline-text"))
			.forEach(function (head) {
				head.addEventListener("click", toggleNextSibling);
			});
	}
})

//Form Dropdown
let selects = document.getElementsByTagName('select');
for (let select of selects) {
	new Choices(select, {
		searchEnabled: false,
		itemSelectText: '',
		maxItemCount: 1,
		placeholder: true,
		placeholderValue: null,

	})
}

// scroll to top
const scrollToTopBtn = document.querySelector('.scroll-to-top-btn') as HTMLElement;

function handleScroll() {
	if (scrollToTopBtn) {
		if (window.scrollY > 200) {
			scrollToTopBtn.style.display = 'block';
		} else {
			scrollToTopBtn.style.display = 'none';
		}
	}
}

handleScroll();

window.addEventListener('scroll', handleScroll);
scrollToTopBtn?.addEventListener('click', () => {
	window.scrollTo({
		top: 0,
		behavior: 'smooth'
	});
});

import animationData from '../utils/hof_logo_animation_schwarz.json';
import animationDataWhite from '../utils/hof_logo_animation_weiss.json';
import { Modal } from "bootstrap";

const desktopLogo = document.querySelector('.desktop-nav .navbar-brand .brand-svg-lottie');
if (desktopLogo) {
	lottie.loadAnimation({
		container: desktopLogo,
		autoplay: true,
		renderer: 'svg',
		loop: true,
		animationData: animationData
	});
}

const mobileLogo = document.querySelector('.mobil-nav .navbar-brand .brand-svg-lottie');
if (mobileLogo) {
	lottie.loadAnimation({
		container: mobileLogo,
		autoplay: true,
		renderer: 'svg',
		loop: true,
		animationData: animationDataWhite
	});
}

// Funktion zum Überprüfen der URL und Öffnen des Modals
function checkHashAndOpenModal() {
	const urlParams = new URLSearchParams(window.location.search);
	const hash = window.location.hash;

	// Überprüfen, ob der Hash und die Parameter in der URL vorhanden sind
	if (urlParams.has('tx_form_formframework[action]') &&
		urlParams.has('tx_form_formframework[controller]') &&
		urlParams.get('tx_form_formframework[action]') === 'perform' &&
		hash === '#oneclick-1353') {

		// Bootstrap Modal öffnen mit JavaScript
		const directRequestModal = document.getElementById('directRequest');
		const modal = new Modal(directRequestModal!);
		modal.show();
	}
}

// Funktion beim Laden der Seite ausführen
window.addEventListener('load', checkHashAndOpenModal);


const btnShowDialog = document.querySelectorAll('.show-dialog') as NodeListOf<HTMLButtonElement>;

if (btnShowDialog.length > 0) {
	btnShowDialog.forEach(btn => {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			const dialog = document.getElementById(`${btn.dataset.value}`) as HTMLDialogElement;
			dialog?.showModal();
			dialog.classList.add('open');
			closeDialog(dialog);
		});
	});
}

const btnOpenDialog = document.querySelectorAll('.open-dialog') as NodeListOf<HTMLButtonElement>;
if (btnOpenDialog.length > 0) {
	btnOpenDialog.forEach(btn => {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			const section = btn.closest('section') as HTMLElement;
			const dialog = section.querySelector('dialog') as HTMLDialogElement;
			dialog?.showModal();
			dialog.classList.add('open');
			closeDialog(dialog);
		});
	});
}

function closeDialog(dialog: HTMLDialogElement) {
	const closeDialogBtn = dialog.querySelector('.btn-close-dialog') as HTMLButtonElement;
	closeDialogBtn.addEventListener('click', (e) => {
		e.preventDefault();
		dialog.close();
		dialog.classList.remove('open');
	});
}


const choicesPliaceholders = document.querySelectorAll('.choices__placeholder');
if (choicesPliaceholders.length > 0) {
	choicesPliaceholders.forEach(placeholder => {
		placeholder.setAttribute('role', 'option');
		placeholder.setAttribute('aria-label', 'Bitte wählen');
	});
}

const formSelects = document.querySelectorAll('select.form-select');
if (formSelects.length > 0) {
	formSelects.forEach(select => {
		// get Attribut title
		const title = select.getAttribute('title');
		const choices = select.closest('.choices');
		if (title && choices) {
			choices.setAttribute('aria-label', title);
		}
	});
}
